module.exports = __webpack_public_path__ + "static/img/step-2.5e0c901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/step-2.png
// module id = Qfjs
// module chunks = 1